const patterns = [
  new RegExp('youtu\\.be/([^#&?]{11})') /** Youtu.be/<id> */,
  new RegExp('\\?v=([^#&?]{11})') /** ?v=<id> */,
  new RegExp('\\&v=([^#&?]{11})') /** &v=<id> */,
  new RegExp('embed\\/([^#&?]{11})') /** Embed/<id> */,
  new RegExp('/v/([^#&?]{11})') /** /v/<id> */,
];

const youtubeReg = new RegExp('youtu\\.?be');
const tokenSplitRef = new RegExp('[\\/\\&\\?=#\\.\\s]', 'g');
const tokenTestRef = new RegExp('^[^#&?]{11}$');

export function getYoutubeId(
  url: string,
  opts = {
    fuzzy: true,
  },
) {
  if (youtubeReg.test(url)) {
    // Look first for known patterns
    let i;

    // If any pattern matches, return the ID
    // eslint-disable-next-line no-plusplus
    for (i = 0; i < patterns.length; ++i) {
      if (patterns[i]?.test(url)) {
        return patterns[i]?.exec(url)?.[1];
      }
    }

    if (opts.fuzzy) {
      // If that fails, break it apart by certain characters and look
      // for the 11 character key
      const tokens = url.split(tokenSplitRef);
      // eslint-disable-next-line no-plusplus
      for (i = 0; i < tokens.length; ++i) {
        if (tokenTestRef.test(tokens[i] as string)) {
          return tokens[i];
        }
      }
    }
  }

  return null;
}
